<template>
    <div class="tab-content">
        <div class="tab-inner-content centered-item">
            <img class="antivirus-coming-soon" :src="activeContent.main.src" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "AntiVirus",
        props: ['activeContent','brand']

    }
</script>

<style scoped>
    .tab-inner-content {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    img.antivirus-coming-soon {
        margin-top: 170px;
    }
</style>